import service from '../services/apiService'
import { getActiveFreeBets } from '~/services/util'

export const state = () => ({
  freeBet: [],
  error: null
})

export const mutations = {
  setFreeBet(state, freeBet) {
    state.freeBet = Array.isArray(freeBet) ? freeBet : []
  },
  setError(state, error) {
    state.error = error
  }
}

export const actions = {
  async getFreeBet({ commit }) {
    try {
      const response = await service.apiCallWithHeader(
        `/casino/free-spins?status=all`
      )
      const activeFreeBets = getActiveFreeBets(response.data?.result || [])
      commit('setFreeBet', activeFreeBets)
      return activeFreeBets
    } catch (error) {
      console.error('Error fetching free bets:', error)
      commit('setError', {
        message: error.message || 'No Internet connection'
      })
      commit('setFreeBet', []) // Ensure freeBet is empty array on error
      return []
    }
  }
}
